import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import { FormFooterWrapper } from './styled/FormFooter';
export default class FormFooter extends Component {
  render() {
    const {
      align,
      children
    } = this.props;
    return /*#__PURE__*/React.createElement(FormFooterWrapper, {
      align: align
    }, children);
  }

}

_defineProperty(FormFooter, "defaultProps", {
  align: 'end'
});